module.exports = __webpack_public_path__ + "h5/img/baozhang.26440b9b.png";